import React from 'react'
import '../App.css';

export default function NotFound() {
  return (
    <div class='centered'>
        <h1 class='landing-title'>404</h1>
        <h3>Page Not Found</h3>
    </div>
  )
}
